import axios from 'axios';
import ACTION_ITEMS from '../actionItems';

export function getSponsorStatistics(userId) {
  return (dispatch) => {
    axios
      .get(`/sponsor/${userId}/statistics`)
      .then((response) => {
        const { status, statistics } = response.data;
        if (status === 'SUCCESS') {
          dispatch(setUserTokens(statistics));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

function setUserTokens(statistics) {
  return {
    type: ACTION_ITEMS.SPONSOR_PORTAL.STATISTICS.SET,
    payload: statistics,
  };
}
